module.exports = __webpack_public_path__ + "img/scorecard-2.9db1ce66.jpg";